import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import CommonFilter from '../../../customControl/CommonFilter';
import CustomTable from '../../../customControl/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { htmlToText } from 'html-to-text';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { formatDate, getDateCombination, getDecodedHTMLRawLength, isImageValidPng, isNullable, onlyAlphabets, onlyAlphabetswithnospace } from '../../commonClass/CommonValidation';
import RichTextBox from '../../../customControl/RichTextBox';
import ReactSwitch from 'react-switch';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';

const Statemaster = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formError, setFormError] = useState({})
  const [editorRef, setEditorRef] = useState(null);
  const [ansref, setAnsRef] = useState(null)
  const [modalShow, setModalShow] = useState(false);
  const [activeId, setActiveId] = useState(false);
  const [listData, setListData] = useState([]);
  const [buttonaddedit, setButtonAddEdit] = useState("Add");
  const [editIndex, setEditIndex] = useState(null)
  const [editdisabled, setEditDisabled] = useState(true);
  const [searchDisabled, setSearchDisable] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const [dropdownList, setDropdownList] = useState([])
  const user = useSelector(store => store.userstatus.tba);
  const [useradd, setUserAdd] = useState(true);
  const [useredit, setUserEdit] = useState(true);
  const [userexport, setUserExport] = useState(true);

  const [searchvalue, setSearchValue] = useState();
  const [searchby, setSerachBy] = useState('All');

  const [formValue, setFormValue] = useState(
    {
      CountryId: 1,
      StateId: 0,
      StateName: '',
      RegionId: 0,
      StateCode: '',
      StateDescription: '',
      IsActive: false,
      FAQList: [],
      UserId: 0,

      // temp
      CountryStateFAQId: 0,
      Question: '',
      Answer: '',

      ImageName: "",
      ImagePath: "",
      fileSize: 0,
      Path: "",
      File: null,
      needToUpload: false
    }
  );

  const [StateImageDelete, setStateImageDelete] = useState("");

  useEffect(() => {
    getlist()
    getcountrydescriptionoption()
  }, []);


  useEffect(() => {
    let pagelink = user?.find(x => {
      if (x.PageLink === window.location.pathname)
        return x.MenuId
    });
    let mid = user?.find(x => x.MenuId === pagelink.MenuId);
    if (mid?.URightView === false && mid?.URightView !== undefined) {
      navigate('/dashboard');
    }
    user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
      setUserAdd(obj.URightAdd);
      setUserEdit(obj.URightEdit);
      setUserExport(obj.URightExport);

    });
  }, [user])


  const validateData = () => {
    let status = true;
    let error = {}
    if (formValue?.StateName?.trim()?.length === 0) {
      error.StateName = 'Please provide state name.';
    }
    if (formValue.StateCode?.trim()?.length === 0) {
      error.StateCode = 'Please Provide State Code.';
    }
    if (formValue.RegionId === 0) {
      error.RegionId = 'Please select Region.';
    }

    if (formValue.ImageName?.trim()?.length <= 0 || formValue.ImagePath?.trim()?.length <= 0 || isNullable?.includes(formValue.ImageName) || isNullable?.includes(formValue.ImagePath)) {
      error.ImageName = 'Please Upload State Image.';
    }
    else if (!isImageValidPng(formValue.ImageName)) {
      error.ImageName = 'Only PNG file type is accepted.';
    }
    else if (formValue?.fileSize > 5) {
      error.ImageName = 'Cannot upload file that exceeds 5 MB.';
    }

    if (getDecodedHTMLRawLength(formValue.StateDescription) === 0) {
      error.StateDescription = 'Please Provide Description.';
    }
    if (getDecodedHTMLRawLength(formValue.StateDescription) > 0 && getDecodedHTMLRawLength(formValue?.StateDescription) > 2500) {
      error.StateDescription = 'Maximum character limit of 2500 reached.';
    }
    if (formValue.FAQList?.length === 0) {
      error.FAQList = 'Please enter at least one question and answer.';
    }

    setFormError(error)

    if (Object?.keys(error)?.length > 0) {
      status = false;
      const id = Object?.keys(error)?.[0];
      document.getElementById(id)?.focus();
    }

    return status;
  }

  const handleAddClick = async () => {
    if (validateData()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let userdata = GetLocalStorage()
        formValue.UserId = userdata?.userMasterID
        const res = await postUsersData('/master/v1/insertupdatestatedetails', formValue);
        if (res?.status) {
          if (formValue?.needToUpload) {
            const isImageUpload = await ImageUpload(formValue?.Path, formValue?.ImageName, formValue?.File)
            if (isImageUpload) {

              if (StateImageDelete) {
                const isImageDelete = await ImageDelete(StateImageDelete);
                if (!isImageDelete) {
                  dispatch({ type: 'ALERTING', message: 'Image delete transaction failed' });
                  getlist();
                  handleClearClick();
                  dispatch(loaderActions.end());
                  return;
                }
              }

              dispatch({ type: 'ALERTING', message: res?.message })
              getlist();
              handleClearClick();
              dispatch(loaderActions.end());
            }
            else {
              dispatch({ type: 'ALERTING', message: 'Try again later!' })
              getlist();
              handleClearClick();
              dispatch(loaderActions.end());
            }
          }
          else {
            dispatch({ type: 'ALERTING', message: res.message })
            getlist();
            handleClearClick();
            dispatch(loaderActions.end());
          }
        }
        else {
          dispatch(loaderActions.end());
          dispatch({ type: 'ALERTING', message: res.message })
        }
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }
    }
  }


  const handleEditview = (type, obj) => {
    setEditDisabled(false);
    setSearchDisable(true);
    setFormError({});
    setFormValue((form) => ({
      ...form,
      StateName: obj?.StateName,
      CountryId: obj?.CountryId,
      FAQList: obj?.FAQList,
      IsActive: obj?.IsActive,
      RegionId: obj?.RegionId,
      StateCode: obj?.StateCode,
      StateDescription: obj?.StateDescription || "",
      StateId: obj?.StateId,
      type: type,
      ImageName: obj?.ImageName,
      ImagePath: obj?.ImagePath,
    }))
    setStateImageDelete(obj?.ImagePath ? CommonFileURLWithFolder + obj?.ImagePath : "");
    setActiveId(obj?.IsActive);
  }

  const getlist = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const res = await getAllData("/master/v1/getstatemasterlist");
      if (res?.status) {
        res?.data?.map((obj, index) => {
          obj.Active = obj.IsActive ? 'Active' : 'InActive'
          obj.Sqn = index + 1
          return obj;
        })
        setListData(res.data);
        setFilterList(res?.data)
      }
      else {
        setListData([]);
        setFilterList([])
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
    dispatch(loaderActions.end());
  }
  const getcountrydescriptionoption = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const res = await getAllData("/master/v1/getstatemasteroptions");
      if (res?.status) {
        const rowregionlist = res?.data?.regionlist || [];
        const region = rowregionlist?.map((obj) => ({
          label: obj?.RegionName,
          value: obj?.RegionId,
        }));
        const rowcountryList = res?.data?.countryList || [];
        const country = rowcountryList?.map((obj) => ({
          label: obj?.CountryName,
          value: obj?.CountryId,
        }));

        setDropdownList({ region, country });
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
    dispatch(loaderActions.end());
  }

  const [richboxheight, setRichBoxHeight] = useState(false)
  const citydetailconfig = useMemo(() => ({
    readonly: false, // all options from https://xdsoft.net/jodit/doc/,
    height: '100%',
    maxHeight: richboxheight === true ? 200 : 500,
    width: '100%',
    statusbar: false,
    disablePlugins: ["source"],
    removeButtons: ["about", "link"],
    toolbarAdaptive: false,
    // autofocus: true,
    defaultMode: "1",
    disabled: formValue?.type === "view"
  }),
    [formValue?.type, richboxheight]
  );

  useEffect(() => {
    const richtexteboxheight = document?.getElementById("layoutSidenav_content")?.clientWidth
    if (richtexteboxheight > 1253) {
      setRichBoxHeight(true)
    }
    else {
      setRichBoxHeight(false)
    }
  }, []);

  const onChange = (name, val) => {
    setEditDisabled(false);
    setFormError({});
    setFormValue((form) => ({ ...form, [name]: val }))
  }

  const handleUploadImage = (e) => {
    setEditDisabled(false);
    setFormError({});

    const file = e?.target?.files?.[0];
    const filename = getDateCombination(file?.name);

    if (file) {
      setFormValue((prev) => ({
        ...prev,
        ImageName: filename,
        ImagePath: `CMS/StateMaster/${filename}`,
        Path: `CMS/StateMaster/`,
        File: file,
        fileSize: (file?.size / 1024) / 1024,
        needToUpload: true,
      }))
    }

  }

  const removeImage = () => {
    setEditDisabled(false);
    setFormError({});

    document.getElementById("StateImgae").value = "";

    setFormValue((prev) => ({
      ...prev,
      ImageName: "",
      ImagePath: "",
      fileSize: 0,
      Path: "",
      File: null,
      needToUpload: false
    }))
  }

  const handleisActive = (e) => {
    if (formValue?.type === 'edit') {
      setModalShow(true);
    }
    else {
      formValue.IsActive = e
      setActiveId(!activeId)
      setFormError({});
    }
  }

  const handleConfirmation = (e) => {
    if (e === true) {
      formValue.IsActive = !activeId
      setActiveId(!activeId)
      setEditDisabled(false);
      setFormError({});
    }
    setModalShow(false);
  }

  const handleClearClick = () => {
    document.getElementById("StateImgae").value = "";
    setFormError({});
    setFormValue((form) => ({
      ...form,
      CountryId: 1,
      StateId: 0,
      StateName: '',
      RegionId: 0,
      StateCode: '',
      StateDescription: '',
      IsActive: false,
      FAQList: [],
      CountryStateFAQId: 0,
      Question: '',
      Answer: '',
      type: 'Add',

      ImageName: "",
      ImagePath: "",
      fileSize: 0,
      Path: "",
      File: null,
      needToUpload: false
    }))
    setActiveId(false);
    setEditDisabled(true);
    setSearchDisable(false);
    setSerachBy('All');
    setSearchValue('');
    handleClearfaq();
    setButtonAddEdit("Add")
    document.querySelectorAll('.jodit-wysiwyg')[0].innerHTML = ''
    // if (editorRef?.current) {
    //   editorRef.current.value = '';
    // }
  }

  const columns = [
    {
      name: 'Sq. No.',
      sortable: true,
      float: "left",
      selector: (resp) => resp.Sqn
    },
    {
      name: 'Country',
      key: 'CountryName',
      sortable: true,
      float: "left",
      selector: (resp) => resp.CountryName
    },
    {
      name: 'State',
      key: 'StateName',
      sortable: true,
      float: "left",
      selector: (resp) => resp.StateName
    },
    {
      name: 'Active',
      key: 'Active',
      sortable: true,
      float: "left",
      selector: (resp) => resp.Active
    },
    {
      name: 'Created Date',
      sortable: true,
      float: "left",
      selector: (resp) => new Date(resp.CreatedDate),
      format: (resp) => formatDate(resp.CreatedDate),
    },
    {
      name: 'Edit',
      selector: (resp) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditview('edit', resp)}></i></button>
    },
    {
      name: 'View',
      selector: (resp) => <i className="fa fa-eye" onClick={() => handleEditview('view', resp)}></i>
    }
  ];

  const validatefaq = () => {
    let status = true;
    let error = {}
    if (formValue.Question?.trim()?.length === 0) {
      error.Question = 'Please enter question.';
      status = false;
    }
    if (getDecodedHTMLRawLength(formValue.Answer) === 0) {
      error.Answer = 'Please enter answer.';
      status = false;
    }
    if (getDecodedHTMLRawLength(formValue.Answer) > 0 && getDecodedHTMLRawLength(formValue?.Answer) > 2000) {
      error.Answer = 'Maximum character limit of 2000 reached.';
      status = false;
    }
    if (error[0] === "SubContinentId") {
      eval(error[0])?.current?.focus();
    }
    else {
      let doc = document?.getElementById(error[0]);
      if (doc !== null)
        doc?.focus();
    }
    setFormError(error)
    return status;
  }

  const handleAddfaq = () => {
    if (validatefaq()) {
      if (editIndex !== null) {
        setFormValue((form) => {
          const updatedFAQList = [...form.FAQList];
          updatedFAQList[editIndex] = {
            CountryStateFAQId: form?.CountryStateFAQId ? form?.CountryStateFAQId : 0,
            Question: form.Question,
            Answer: form?.Answer
          };

          return {
            ...form,
            FAQList: updatedFAQList,
            CountryStateFAQId: 0,
            Answer: '',
            Question: '',
          };
        });
      }
      else {
        setFormValue((form) => {
          const updatedFAQList = [...form.FAQList, {
            CountryStateFAQId: form?.CountryStateFAQId ? form?.CountryStateFAQId : 0,
            Question: form.Question,
            Answer: form?.Answer
          }];

          return {
            ...form,
            FAQList: updatedFAQList,
            CountryStateFAQId: 0,
            Answer: '',
            Question: '',
          };
        });
      }
      setEditIndex(null)
      setButtonAddEdit("Add")
      if (ansref?.current) {
        onChange('Question', '')
        setTimeout(() => {
          document.querySelectorAll('.jodit-wysiwyg')[1].innerHTML = ''
          formValue.Answer = ''
          document.querySelectorAll('.jodit-wysiwyg')[1]?.click()
        }, 200);
      }
    }
  }

  const handleeditfaq = (index) => {
    setFormError({})
    setEditIndex(index)
    setButtonAddEdit("Update")
    setFormValue((form) => ({
      ...form,
      CountryStateFAQId: form?.FAQList?.[index]?.CountryStateFAQId,
      Question: form?.FAQList?.[index]?.Question,
      Answer: form?.FAQList?.[index]?.Answer
    }));
  }

  const handleremovefaq = (index) => {
    setFormError({})
    setFormValue((form) => {
      const updatedFAQList = [...form.FAQList];
      updatedFAQList?.splice(index, 1);
      return {
        ...form,
        FAQList: updatedFAQList,
        CountryStateFAQId: 0,
        Answer: '',
        Question: '',
      };
    });
  }

  const handleClearfaq = () => {
    setFormError({})
    setButtonAddEdit('Add')
    setFormValue((form) => ({
      ...form,
      CountryStateFAQId: 0,
      Answer: '',
      Question: '',
    }))
    if (ansref?.current) {
      onChange('Question', '')
      setTimeout(() => {
        document.querySelectorAll('.jodit-wysiwyg')[1].innerHTML = ''
        formValue.Answer = ''
        document.querySelectorAll('.jodit-wysiwyg')[1]?.click()
      }, 200);
    }
  }

  return (
    <>
      <div className="container-fluid mt-4 heading_color">
        <h3>State Master</h3>
      </div>
      <div className="container-fluid form_border py-5 mb-3">
        <form action="" >
          <div className="mb-3 row mx-1">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row">
                <div className='col-lg-6 col-sm-6 '>
                  <div className='row'>
                    <div className="col-lg-4 col-md-12 mb-1">
                      <label htmlFor="StateName" className="col-form-label required">
                        State Name </label>
                    </div>
                    <div className="col-lg-8 mb-1 col-md-12">
                      <input type="text"
                        id="StateName"
                        placeholder="State Name"
                        className="form-control"
                        name="StateName"
                        maxLength={20}
                        value={formValue.StateName}
                        onChange={(e) => onChange('StateName', onlyAlphabets(e.target?.value))}
                        disabled={formValue?.type === 'view'} />
                      {formError?.StateName && <p className="text-danger mb-0"> {formError?.StateName} </p>}
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 col-sm-6 '>
                  <div className='row'>
                    <div className="col-lg-4 col-md-12 mb-1">
                      <label htmlFor="StateCode" className="col-form-label required" >
                        State Code</label>
                    </div>
                    <div className=" col-lg-8 mb-1 col-md-12">
                      <input type="text"
                        id="StateCode"
                        placeholder="State Code"
                        className="form-control"
                        name="StateCode"
                        maxLength={5}
                        value={formValue.StateCode}
                        onChange={(e) => onChange('StateCode', onlyAlphabetswithnospace((e.target?.value)?.toUpperCase()))}
                        disabled={formValue?.type === 'view'} />
                      {formError?.StateCode && <p className="text-danger mb-0"> {formError?.StateCode} </p>}
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 col-sm-6 '>
                  <div className='row'>
                    <div className="col-lg-4 col-md-12 mb-1">
                      <label htmlFor="RegionId" className={`col-form-label required`}>Region</label>
                    </div>
                    <div className=" col-lg-8 mb-1 col-md-12">
                      <Select
                        inputId='RegionId'
                        className="dropdown select_dropdown"
                        options={dropdownList?.region}
                        value={dropdownList?.region?.filter((region) => {
                          return region.value === formValue.RegionId;
                        })}
                        onChange={(e) => onChange("RegionId", e?.value)}
                        isDisabled={formValue?.type === 'view'}
                        isSearchable={true}

                      />
                      {formError?.RegionId && <p className="text-danger mb-0"> {formError?.RegionId} </p>}
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 col-sm-6 '>
                  <div className='row'>
                    <div className="col-lg-4 col-md-12 mb-1">
                      <label htmlFor="CountryId" className={`col-form-label`}>Country</label>
                    </div>
                    <div className=" col-lg-8 mb-1 col-md-12">
                      <Select
                        id="CountryId"
                        className="dropdown select_dropdown"
                        options={dropdownList?.country}
                        value={dropdownList?.country?.filter((country) => {
                          return country.value === formValue.CountryId;
                        })}
                        onChange={(e) => onChange("CountryId", e?.value)}
                        isDisabled={true}
                        isSearchable={true}

                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6">
                  <div className="row">
                    <div className="col-lg-4 col-md-12 mb-1">
                      <label htmlFor="StateImgae" className="col-form-label required">Upload Image</label>
                    </div>
                    <div className="col-lg-8 col-md-12 mb-1">
                      <div className="input-group">
                        <input
                          className='form-control btn_add'
                          type="file"
                          id="StateImgae"
                          accept=".png"
                          onChange={handleUploadImage}
                          disabled={formValue?.type === 'view'}
                        />
                        <label className="input-group-text" htmlFor="StateImgae">Browse</label>
                      </div>
                      {formValue?.ImageName && <p className="mb-0"> {formValue?.ImageName} </p>}
                      {formError?.ImageName && <p className="text-danger mb-0"> {formError?.ImageName} </p>}
                    </div>
                  </div>
                </div>

                <div className='col-md-12 col-sm-12'>
                  <div className='row'>
                    <div className="col-lg-2 col-md-12 mb-1">
                      <label htmlFor="StateDescription" className="col-form-label required">Enter Description</label>
                    </div>
                    <div className="col-lg-10 col-md-12 col-sm-12 mb-lg-1 mb-md-1" key='StateDescription'>
                      <RichTextBox
                        setRef={setEditorRef}
                        field="StateDescription"
                        fieldvalue={formValue.StateDescription}
                        tabIndex={1}
                        // OnChangeofRichBox={(e) => { handleCityDetailChange(e) }}
                        OnChangeofRichBox={(value) => { formValue.StateDescription = value; setEditDisabled(false) }}
                        textconfig={citydetailconfig}
                      />
                      {formError?.StateDescription && <p className="text-danger mb-0"> {formError?.StateDescription} </p>}
                    </div>
                  </div>
                </div>
                <div className='col-md-6 col-sm-6'>
                  <div className='row'>
                    <div className="col-lg-4 col-md-12 mb-1">
                      <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                    </div>
                    <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                      <ReactSwitch
                        onChange={handleisActive}
                        checked={activeId}
                        className="react-switch"
                        disabled={formValue?.type === 'view'}
                      />
                    </div>
                    <ConfirmationModal
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                      noconfirm={() => handleConfirmation(false)}
                      yesconfirm={() => handleConfirmation(true)}
                    />
                  </div>
                </div>
                <div>
                  <div className="accordion mb-3" id="accordionPanelsStayOpenExample">
                    {formError?.FAQList && <p className="text-danger text-center mb-0"> {formError?.FAQList} </p>}
                    <div className="accordion-item mb-3">
                      <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                        <button className="accordion-button border_set" id='faqaccordion' type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                          FAQ
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                        <div className="accordion-body">
                          <div className='col-lg-12 col-sm-12 '>
                            <div className='row'>
                              <div className="col-lg-2 col-md-12 mb-1">
                                <label htmlFor="Question" className="col-form-label required" >
                                  Enter Question</label>
                              </div>
                              <div className="col-lg-10 mb-1 col-md-12">
                                <input type="text"
                                  id="Question"
                                  placeholder="Enter Question"
                                  className="form-control"
                                  name="Question"
                                  value={formValue.Question}
                                  onChange={(e) => onChange('Question', e.target?.value)}
                                  maxLength={100}
                                  disabled={formValue?.type === 'view'} />
                                {formError?.Question && <p className="text-danger mb-0"> {formError?.Question} </p>}
                              </div>
                            </div>
                          </div>
                          <div className='col-md-12 col-sm-12'>
                            <div className='row'>
                              <div className="col-lg-2 col-md-12 mb-1">
                                <label htmlFor="Answer" className="col-form-label required">Type Answer</label>
                              </div>
                              <div className="col-lg-10 col-md-12 col-sm-12 mb-lg-1 mb-md-1" key='Answer2'>
                                <RichTextBox
                                  setRef={setAnsRef}
                                  field="Answer"
                                  fieldvalue={formValue.Answer}
                                  tabIndex={1}
                                  // OnChangeofRichBox={(e) => { handleCityDetailChange(e) }}
                                  OnChangeofRichBox={(value) => { formValue.Answer = value; setEditDisabled(false) }}
                                  textconfig={citydetailconfig}
                                />
                                {formError?.Answer && <p className="text-danger mb-0"> {formError?.Answer} </p>}
                              </div>
                            </div>
                          </div>
                          <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                            <table id="data" className="table table-hover" >
                              <thead>
                                <tr>
                                  <th>Question
                                  </th>
                                  <th className='text-center'>Answer
                                  </th>
                                  <th className='text-end pe-4' style={{ maxWidth: '10px' }}>Edit
                                  </th>
                                  <th className='text-end pe-4' style={{ maxWidth: '10px' }}>Remove
                                  </th>
                                </tr>
                              </thead>
                              <tbody id="location-data">
                                {formValue?.FAQList && formValue?.FAQList?.map((element, index) => {
                                  return (
                                    <tr class="ReactTable" key={index}>
                                      <td >{element.Question}</td>
                                      <td className='text-center' style={{ wordBreak: 'break-word' }}>{htmlToText(element.Answer)}</td>
                                      <td className='text-end'>
                                        <button type="button" class="btn btn-primary mx-1" onClick={() => handleeditfaq(index)} id="btnAdd" disabled={formValue?.type === 'view'} >Edit</button>
                                      </td>
                                      <td className='text-end'>
                                        <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={() => handleremovefaq(index)} disabled={formValue?.type === 'view'}>Remove</button>
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div className=" d-flex justify-content-center mb-4">
                            {useradd === false && buttonaddedit === "Add" ?
                              <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddfaq} disabled={!useradd || formValue?.type === 'view'}>{buttonaddedit}</button> :
                              <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddfaq} disabled={!useredit || formValue?.type === 'view'}>{buttonaddedit}</button>}
                            <button type="button" className="btn btn-primary mx-1" id="btnClear" disabled={formValue?.type === 'view'} onClick={handleClearfaq}>Clear</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {
            (formValue?.File || formValue?.ImagePath) &&
            <div className='text-center mb-4' >
              <img
                src={
                  formValue?.needToUpload ?
                    URL.createObjectURL(formValue?.File) :
                    `${CommonFileURLWithFolder}${formValue?.ImagePath}`
                }
                loading='lazy'
                className=""
                alt={formValue?.ImageFileName}
                height={"200px"}
                aspect-ratio={3 / 2}
              />
              <button
                className='closebtnimg'
                type="button"
                data-close
                onClick={(e) => removeImage()}
                disabled={formValue?.type === 'view'}
              >
                &times;
              </button>

            </div>
          }

          <div className=" d-flex justify-content-center mb-4">
            {formValue?.type === "edit" ?
              <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled || !useredit}>Update</button> :
              <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={formValue?.type === 'view' || !useradd}>Add</button>}
            <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
          </div>
          <CommonFilter
            columns={columns}
            filterList={filterList}
            searchDisabled={searchDisabled}
            getdata={getlist}
            setlistdata={setListData}
            searchvalue={searchvalue}
            setSearchValue={setSearchValue}
            searchby={searchby}
            setSerachBy={setSerachBy}
          />

          <CustomTable
            columns={columns}
            data={listData}
            PdfExport={false}
            ExportToExcel={false}
            disabled={!userexport}
          />
        </form>
      </div>
    </>
  )
}

export default Statemaster